module.exports = [{"default_jump":"","delay":"0","desc":"请根据您在任务执行过程中所遇到的实际情况进行备注。若无，请直接提交，结束答题","descPrefix":"","guideAudio":[],"guideText":"","guideVideo":[],"images":[],"mtext":[{"id":"OPT201907010316101","inputMax":null,"inputMin":null,"inputType":"text","required":false,"title":"特殊情况报备"}],"referStepId":"","stepId":"Q201907170350281","title":"【报备】特殊情况备注","titleAlias":"","type":"mtext","allow_media_download":2,"allow_screen_capture":2}]


//////////////////
// WEBPACK FOOTER
// ./src/views/step-template/data/step-template-append-questions.json
// module id = 3650
// module chunks = 6